"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = exports.Constants = void 0;
class Constants {
    static FALLBACK_CURRENCY = "usd";
    static FALLBACK_TAX_TYPE = "no_tax";
    static FALLBACK_TIMEZONE = "America/New_York";
}
exports.Constants = Constants;
/**
 * Error codes
 */
class AUTH_ERROR_CODES {
    static EMAIL_ALREADY_IN_USE = "auth/email-already-in-use";
}
class SUBSCRIPTION_ERROR_CODES {
    static SUBSCRIPTION_ALREADY_EXISTS = "subscription/subscription-already-exists";
}
class ErrorCodes {
    static Auth = AUTH_ERROR_CODES;
    static Subscription = SUBSCRIPTION_ERROR_CODES;
}
exports.ErrorCodes = ErrorCodes;
//# sourceMappingURL=constants.js.map